import React from "react";
import ReactDOM from "react-dom";
// import { Provider } from "react-redux";
import Routes from "./routes";
// import store from "./store";
import ErrorBoundary from "./commons/ErrorPage";

import "antd/dist/antd.css";
import "./index.css";

import "./App.css";
import registerServiceWorker from "./registerServiceWorker";
import ReactGA from "react-ga";

// import { PersistGate } from "redux-persist/integration/react";

import AppProvider from "./store";

// const AppProvider = createProvider();

// ReactDOM.render(
//   <ErrorBoundary>
//     <Provider store={store.store}>
//       <PersistGate loading={null} persistor={store.persistor}>
//         <Routes />
//       </PersistGate>
//     </Provider>
//   </ErrorBoundary>,
//   document.getElementById("root")
// );

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);

ReactDOM.render(
  <ErrorBoundary>
    <AppProvider>
      <Routes />
    </AppProvider>
  </ErrorBoundary>,
  document.getElementById("root")
);
registerServiceWorker();
